import React from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as TwitterIcon } from "../../../assets/svg/twitter-logo.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const Twitter = () => {
    const dispatch = useDispatch();
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                explore_twitter: 1,
            },
        };
        localStorage.setItem("activeModule", "Page Analytics");
        dispatch(setActiveModule("Page Analytics"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <TwitterIcon className="icon_content" />
                        <span className="content_title">X</span> {/*Changed Twitter name to X */}
                    </div>
                    <div className="text_content">
                        <p>{`This section will provide insights of your connected twitter pages.`}</p>
                        <p>In this section, you can check Tweet activity, measure engagement and learn how to make your Tweets more successful.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/owned-page/twitter">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/_xA77F48Hqc"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default Twitter;
